import { Phone, Mail, MessageCircle } from "lucide-react";
import { SITE } from "@/site";

export const StickyBar = () => (
  <div className="md:hidden fixed bottom-0 left-0 right-0 z-50 glass border-t border-white/10 px-4 py-3 flex gap-3" data-testid="sticky-contact-bar">
    <a href={`tel:${SITE.phoneRaw}`} data-testid="sticky-phone"
       className="flex-1 flex items-center justify-center gap-2 bg-white/5 text-[#F8FAFC] py-3 rounded-xl font-mono-label text-[10px]">
      <Phone size={16} className="text-[#FACC15]" /> Call
    </a>
    <a href={`https://wa.me/${SITE.whatsapp}`} target="_blank" rel="noopener noreferrer" data-testid="sticky-whatsapp"
       className="flex-1 flex items-center justify-center gap-2 bg-[#FACC15] text-[#020617] py-3 rounded-xl font-mono-label text-[10px] font-semibold">
      <MessageCircle size={16} /> WhatsApp
    </a>
    <a href={`mailto:${SITE.email}`} data-testid="sticky-email"
       className="flex-1 flex items-center justify-center gap-2 bg-white/5 text-[#F8FAFC] py-3 rounded-xl font-mono-label text-[10px]">
      <Mail size={16} className="text-[#FACC15]" /> Email
    </a>
  </div>
);
